import Alert from '@mui/material/Alert'
import { styled } from '@mui/system'

export const CustomAlert = styled(Alert)({
  // Add your common Alert (error) styles here
  marginBottom: '18px',
  variant: 'h5'
})
